export var libsMap = {
    // 'echarts': `${process.env.STATIC_RES_DOMAIN}/libs/echarts/4.9.0/echarts-location.min.js`,
    // echarts: `${process.env.STATIC_RES_DOMAIN}/libs/echarts/5.1.2/echarts-flow.min.js`,
    echarts: '/echarts.min.js',
    uLink: 'https://g.alicdn.com/jssdk/u-link/index.min.js',
    // https://developer.work.weixin.qq.com/document/path/96914
    wxSDK: 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js',
    // 企业微信 SDK
    iosJweixin: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
    jwxwork: 'https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js',
    jwxwecom: 'https://wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.3.3.js'
};
// https://lbs.amap.com/api/javascript-api-v2/guide/abc/load
// export const aMapServiceHost = 'https://location.locxx.com/_AMapService2024';
// 因为高德地图未获得商用授权，所以需要经常换
// export const aMapServiceHost = 'https://location.locxx.com/_AMapService20240808';
// 商用版！！！
// export const aMapServiceHost = 'https://location.locxx.com/_AMapService20240904';
export var aMapServiceHost = process.env.AMAP_SERVICE_HOST;
